import { useNavigate } from "react-router";
import { ReactComponent as EditIcon } from "../../assets/icons/tables/edit-icon.svg";
import { ReactComponent as TrashIcon } from "../../assets/icons/tables/trash-icon.svg";
import {
  ILeadingSource,
  useLeadingSources,
} from "../../store/useLeadingSources";

export const LeadingSourcesTable = () => {
  /** Hooks */
  const { leadingSources, deleteLeadingSource } = useLeadingSources();
  const navigate = useNavigate();

  return (
    <div className="relative overflow-x-auto">
      <table className="w-full text-base font-normal font-satoshi text-left rtl:text-right text-dark">
        <thead className="font-medium bg-gray-50">
          <tr>
            <th scope="col" className="px-6 py-3">
              Name
            </th>
            <th scope="col" className="px-6 py-3 text-right">
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          {leadingSources?.length
            ? leadingSources.map((leadingSource: ILeadingSource) => (
                <tr
                  key={leadingSource?._id}
                  className="bg-white hover:bg-gray-100 cursor-pointer transition ease-linear border-b"
                >
                  <td
                    onClick={() =>
                      navigate(`/edit-leading-source/${leadingSource?._id}`)
                    }
                    className="px-6 py-4 whitespace-nowrap"
                  >
                    {leadingSource.name}
                  </td>
                  <td className="px-6 py-4 flex items-center justify-end cursor-pointer">
                    <EditIcon
                      onClick={() =>
                        navigate(`/edit-leading-source/${leadingSource?._id}`)
                      }
                      className="mr-7"
                    />
                    <TrashIcon
                      onClick={() => {
                        const confirmDelete = window.confirm(
                          "Are you sure you want to delete this leadingSource?"
                        );
                        if (confirmDelete) {
                          deleteLeadingSource(leadingSource._id as string);
                        }
                      }}
                    />
                  </td>
                </tr>
              ))
            : null}
        </tbody>
      </table>
    </div>
  );
};
